import { useTranslate } from '@va/localization';
import { ConfirmationDialogType, ConfirmationModal } from '@va/shared/util-confirmation';

const DeleteSegmentsConfirmationDialog: ConfirmationDialogType = ({ onClose, onConfirm }) => {
  const translate = useTranslate();

  return (
    <ConfirmationModal
      title={translate('segments.actions.delete')}
      isOpen={true}
      onConfirmation={onConfirm}
      onClose={onClose}
      info={translate('segments.actions.info.delete')}
    />
  );
};

export default DeleteSegmentsConfirmationDialog;
